import React from 'react';
import { useTranslation } from 'react-i18next';
import ExpandMore from '@mui/icons-material/ExpandMore';
import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ResidentSettingsDetailsScenarioRow from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/resident-settings-details-scenario-row';
import useResidentSettingDetailsScenariosAccordion from 'features/residents/resident-settings/components/resident-setting-details-scenarios-accordion/hooks';
import styles from './resident-setting-details-scenarios-accordion.module.scss';

const ResidentSettingDetailsScenariosAccordion = (): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');

  const { shouldShowScenarios, hasScenarios, organisationUnitScenarios, toggleShouldShowScenarios } =
    useResidentSettingDetailsScenariosAccordion();
  return (
    <Accordion expanded={shouldShowScenarios} disableGutters>
      <AccordionSummary
        sx={{ padding: 0, margin: '12px 0 0 0', '.MuiAccordionSummary-content': { margin: '0' } }}
        expandIcon={<ExpandMore onClick={toggleShouldShowScenarios} />}
        aria-label="Expand"
        aria-controls="additional-actions1-content"
      >
        <Grid
          className={styles.accordionSummaryContent}
          onClick={toggleShouldShowScenarios}
          onKeyDown={(e) => e.key === 'Enter' && toggleShouldShowScenarios}
        >
          <NotificationsNoneOutlined onClick={toggleShouldShowScenarios} />
          <Typography variant="h5">{t('details.scenariosDividerText')}</Typography>
        </Grid>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: '0 0 8px 0', margin: 0 }}>
        {hasScenarios && organisationUnitScenarios ? (
          [...organisationUnitScenarios].map((organisationUnitScenario, index) => (
            <ResidentSettingsDetailsScenarioRow
              key={organisationUnitScenario.id}
              index={index}
              organisationUnitScenario={organisationUnitScenario}
            />
          ))
        ) : (
          <Typography variant="subtitle1">{t('details.noScenarios')}</Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default ResidentSettingDetailsScenariosAccordion;
